import { setDateTime, setSelectedCity } from '../../actions';
import { identityPayload, createReducer, forAction } from '../../utils';

const initialState = {
  client: null,
  server: null,
};

export default createReducer(
  [forAction(setDateTime, identityPayload)],
  initialState,
  [setSelectedCity],
);
